import { render, staticRenderFns } from "./LegacyRemoteDomainWizard.vue?vue&type=template&id=3a34b3bc&"
import script from "./LegacyRemoteDomainWizard.vue?vue&type=script&lang=js&"
export * from "./LegacyRemoteDomainWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports